<template >
  <b-container fluid v-if="totalLiquidacion != null && formModel.itemSelected!='Integración IUSA'" style="padding:0px;">


     <b-row style="margin-top:-50px; margin-left:10px; margin-bottom:25px; " v-if="windowWidth>765">
        <b-col><b-icon style="color:gray; cursor:pointer;" icon="printer" @click="generarOrdenPago(true)"/></b-col>
    </b-row>


    <b-row align-h="end" >
        <b-col cols="12" lg="6">  
            <b-alert variant="danger" :show="msgErrorOrdenPago != null" :dismissible="true">
                {{msgErrorOrdenPago}}
            </b-alert>
        </b-col>
    </b-row>
    
    <b-row align-h="end" v-if="anomalia!=null && anomalia!='' ">
        <b-col cols="12" lg="6">  
            <b-alert variant="danger" :show="anomalia!=null && anomalia!=''" :dismissible="true">
                {{"La liquidación presenta "+anomalia }}
            </b-alert>
        </b-col>
    </b-row>

    <b-row align-h="end">
        <b-col cols="9"  md="5" lg="6" xl="4"  v-if="codeClient=='demo' ">
            <br>
            <b-row align-h="center">
                <b-col>
                    <b-button  @click="isShowConvenio=true" variant="warning" size="lg" block>
                        <b-icon icon="file-spreadsheet-fill"/>
                        <strong> Convenio</strong>
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="9"  md="5" lg="6" xl="4" v-if="subsidiosAplicados!=null && subsidiosAplicados.length>0" >
            <br>
            <b-row align-h="center">
                <b-col>
                    <b-button  @click="isShowAplicarDescuento=true" variant="danger" size="lg" block>
                        <b-icon icon="person-plus-fill"/>
                        <strong> Subsidio</strong>
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="9"  md="5" lg="6" xl="4" v-if="formModel.itemSelected!=this.$OrdenPagoItem && !catalogCobro.cobroParquimetro">
            <br>
            <b-row align-h="center">
                <b-col>
                    <!-- <b-dropdown style="min-width: 100%;" split right @click="generarOrdenPago(false)" variant="primary" size="lg" text="Formato de Pago">
                        <b-dropdown-item @click="generarOrdenPago(true)">Solo Imprimir</b-dropdown-item>
                    </b-dropdown> -->
                    <b-button block @click="showConfirmaOrden()" variant="info" size="lg">
                        <b-icon icon="file-spreadsheet-fill"/>
                        <strong> Formato de Pago</strong>
                    </b-button>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-form-checkbox v-model="formModel.isLineaCaptura" value="true" unchecked-value="false">
                    Incluir línea de captura
                </b-form-checkbox>
            </b-row>
        </b-col>
        <b-col cols="9" md="5"  lg="6" xl="4" v-if="formModel.itemSelected!=$OrdenPagoItem && catalogCobro.permisoCobro || formModel.itemSelected==$OrdenPagoItem && catalogCobro.permisoCobroOrden" >
            <br>
            <b-row align-h="center">
                <b-col>
                    <b-button block size="lg" variant="info" @click="showConfirmacionCobro()">
                        <b-spinner v-if="isCobrando"></b-spinner>
                        <b-icon v-if="!isCobrando" icon="cash-stack"/>
                        <strong v-if="isCobrando"> Cobrando . . .</strong>
                        <strong v-if="!isCobrando"> Cobrar </strong>
                    </b-button>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-form-checkbox v-model="formModel.isConFacturaGral" value="true" unchecked-value="false">
                    Incluir cfdi público en general
                </b-form-checkbox>
            </b-row>
        </b-col>
        <br>
    </b-row>
    <b-row align-h="center">
        <b-spinner variant="primary" v-if="isGenerando"></b-spinner>
    </b-row>
    
   

    <canvas v-show="false" id="barcode"></canvas>
    <!--  MODALS -->
    <b-modal v-model="isShowModalOrdenPago" size="lg" hide-footer>
        <b-embed id="embed1" type="iframe" :src='pdfGenerated'></b-embed>
        <b-row>
            <b-button block variant="success" @click="printOrdenPago" size="lg">IMPRIMIR</b-button>
        </b-row>
        <b-row class="row-button-download">
            <b-button block variant="primary" @click="downloadOrdenPago" size="lg">DESCARGAR</b-button>
        </b-row>
    </b-modal>

    <b-modal v-model="isShowModalLineaCaptura" size="lg" hide-footer>
        <b-embed id="embed1" type="iframe" :src='pdfGenerated'></b-embed>
        <b-row>
            <b-button block variant="success" @click="printOrdenPago" size="lg">IMPRIMIR</b-button>
        </b-row>
        <b-row class="row-button-download">
            <b-button block variant="primary" @click="downloadLinea" size="lg">DESCARGAR</b-button>
        </b-row>
    </b-modal>

    <b-modal hide-footer title="¿Desea continuar con el cobro?" v-model="isShowConfirmacionCobro"  header-bg-variant="dark" header-text-variant="light">
        <b-row align-h="center" align="center">
            <b-col cols="12">
                <h5>Seleccione la forma de pago</h5>
            </b-col>
            <b-col cols="11" md="10" lg="8" class=" mb-4">
                <b-form-select v-model="formaPago" :options="formasPago" @change="configFormaPago()"></b-form-select>
            </b-col>
            <b-col cols="12">
                <b-row align="center" align-h="center" v-if="formaPago=='Efectivo'">
                    <b-col cols="12"><h5><b>Total a Cobrar: </b></h5><h5 style="color:red;"><b>$ {{totalLiquidacion}}</b></h5> </b-col>
                    <b-col class="mt-3" cols="12"><h5><b>Recibido: </b></h5> </b-col>
                    <b-col cols="12" md="10" lg="6"><b-form-input style="text-align: center;" autofocus :state="dineroRecibido!=null && dineroRecibido!=''" type="number" v-model="dineroRecibido" @input="calculaCambio"></b-form-input> </b-col>
                    <b-col class="mt-3" cols="12"><h5><b>Cambio: </b></h5><h5 style="color:red;"><b>$ {{cambioDinero}}</b></h5> </b-col>
                </b-row>

                <b-row align="center" align-h="center" v-if="formaPago!='Efectivo'">
                    <b-col cols="12" md="10" lg="7" class="mt-2"><h6 style="color:gray">Información del pago</h6></b-col>
                    <b-col cols="12" md="10" lg="7" class="mt-2">
                        <b-form-checkbox v-if="this.mostrarOpcionPinpad" v-model="activarPinpad" >Cobrar con Pinpad</b-form-checkbox>
                    </b-col>
                    <div v-if="!activarPinpad">
                        <b-col cols="12"   class="mt-2"><b-form-input style="text-align: center;" :placeholder="formaPago=='Cheque'?'No. Cheque': formaPago=='Transferencia'?'No. Cuenta':'No. Tarjeta'" type="text" v-model="numTarjeta"></b-form-input> </b-col>
                        <b-col cols="12"   class="mt-2"><b-form-input style="text-align: center;" placeholder="Banco Emisor"  type="text" v-model="bancoEmisor"></b-form-input> </b-col>
                        
                        <div v-if="formaPago!='Cheque'">
                            <b-col cols="12"  class="mt-2"><b-form-input style="text-align: center;" placeholder="Banco Receptor" type="text" v-model="bancoReceptor"></b-form-input> </b-col>                    
                            <b-col cols="12"  class="mt-2"><b-form-input style="text-align: center;" placeholder="No. Autorización"  type="text" v-model="noAutorizacion"></b-form-input> </b-col>
                        </div>

                    </div>                    
                </b-row>
                <b-row align-h="center" v-if="activarPinpad && catalogCobro.mesesPinpad.length>0 && formaPago.includes('dito')" class="mt-4">
                    <b-col cols="11" md="7" lg="5" >
                        <b>Meses sin intereses</b>
                        <b-form-select  v-model="mesesPinpad" :options="catalogCobro.mesesPinpad"></b-form-select>
                    </b-col>
                </b-row>

            </b-col>
            <b-col class="mt-3">
                <b-button variant="secondary" @click="isShowConfirmacionCobro=false">Cancelar <b-icon icon="x-circle-fill"/></b-button>
            </b-col> 
            <b-col class="mt-3">
                <b-button variant="success" @click="cobrar">Cobrar  <b-icon icon="arrow-right-circle-fill"/></b-button>
            </b-col>
            <!-- {{activarPinpad}} -->
        </b-row>
        
    </b-modal>

    <b-modal hide-footer title="¿Desea generar el Formato de Pago?" v-model="isShowConfirmacionOrden" header-bg-variant="dark" header-text-variant="light">
        <b-row align-h="center" align="center">
            <b-col>
                <b-button variant="success" @click="generarOrdenPago(false)">Si, Generar</b-button>
            </b-col>
            <b-col>
                <b-button variant="secondary" @click="isShowConfirmacionOrden=false">No, Cancelar</b-button>
            </b-col>
        </b-row>
        <b-row align-h="center" align="center" class="mt-5">
            <b-col><b-form-checkbox v-model="opcionesDefaultOrden"><h6>Aplicar fecha de vencimiento del sistema</h6></b-form-checkbox></b-col>
        </b-row>
        <b-row align-h="center" align="center"  v-if="!opcionesDefaultOrden">

            <b-col cols="12" class="mt-2">
                <b-form-group >
                <b-form-radio   v-model="tipoVencimiento" value="a"  @change="asignaFechaVencimientoPorDias(null)">Ingresar manualmente</b-form-radio>
                <b-form-radio  v-model="tipoVencimiento" value="b" @change="asignaFechaVencimientoPorDias(0)">Hoy</b-form-radio>
                <b-form-radio  v-model="tipoVencimiento" value="c" @change="asignaFechaVencimientoPorDias(1)">Mañana</b-form-radio>
                <b-form-radio  v-model="tipoVencimiento" value="d" @change="asignaFechaVencimientoPorDias(15)">15 días naturales</b-form-radio>
                </b-form-group>
            </b-col>

            <b-col cols="8" md="7" lg="5" class="mt-3">
                <b-form-input size="sm"  type="date" v-model="fechaVenceOrden" ></b-form-input>
                <span style="color:red; font-size: 65%;">Ingrese una fecha de vencimiento</span>
            </b-col>
            <b-col cols="8" class="mt-3">
                <b-form-input size="sm"  type="text" placeholder="Ingrese una observación" v-model="observacionOrden" ></b-form-input>
            </b-col>
        </b-row>
    </b-modal>

    <b-modal hide-footer title="Aplicación de beneficios fiscales" v-model="isShowAplicarDescuento" header-bg-variant="dark" header-text-variant="light">
        <b-row align-h="center" align="center">
            <b-col>
                <b-row v-for="subsidio in subsidiosAplicados" :key="subsidio.no" style="border-bottom: 1px solid #E0E0E0;" class="mb-2">
                    <b-col cols="9"><h5><b>{{subsidio.nombre}}</b></h5></b-col>
                    <b-col cols="3" v-if="!subsidio.aplicado"><b-button @click="agregarClave(subsidio.clave, subsidio.nombre, subsidio.importe, subsidio.actualizacion, subsidio.recargo, subsidio.multa, subsidio.gastos)" size="sm" variant="success">Aplicar <b-icon icon="person-check-fill"/></b-button></b-col>
                    <b-col cols="3" v-if="subsidio.aplicado"><b-button @click="eliminarClave(subsidio.clave, subsidio.no)" size="sm" variant="danger">Quitar <b-icon icon="person-x-fill"/></b-button></b-col>
                    <b-col v-if="!subsidio.aplicado">
                        <b-row class="mt-2">
                            <b-col v-if="subsidio.parametrizableImporte" cols="6"><b class="text-second">Importe</b> {{'(Hasta '+subsidio.msjeParametroImporte + ' %)'}}</b-col>
                            <b-col v-if="subsidio.parametrizableImporte" cols="6"><b-form-input type="number" size="sm" v-model="subsidio.importe"></b-form-input></b-col>
                            <b-col v-if="subsidio.parametrizableActualizacion" cols="6"><b class="text-second">Actualización</b> {{'(Hasta '+subsidio.msjeParametroActualizacion + ' %)'}}</b-col>
                            <b-col v-if="subsidio.parametrizableActualizacion" cols="6"><b-form-input type="number" size="sm" v-model="subsidio.actualizacion"></b-form-input></b-col>
                            <b-col v-if="subsidio.parametrizableRecargo" cols="6"><b class="text-second">Recargo</b> {{'(Hasta '+subsidio.msjeParametroRecargo + ' %)'}}</b-col>
                            <b-col v-if="subsidio.parametrizableRecargo" cols="6"><b-form-input type="number" size="sm" v-model="subsidio.recargo"></b-form-input></b-col>
                            <b-col v-if="subsidio.parametrizableMulta" cols="6"><b class="text-second">Multa</b> {{'(Hasta '+subsidio.msjeParametroMulta + ' %)'}}</b-col>
                            <b-col v-if="subsidio.parametrizableMulta" cols="6"><b-form-input type="number" size="sm" v-model="subsidio.multa"></b-form-input></b-col>
                            <b-col v-if="subsidio.parametrizableGastos" cols="6"><b class="text-second">Gastos</b> {{'(Hasta '+subsidio.msjeParametroGastos + ' %)'}}</b-col>
                            <b-col v-if="subsidio.parametrizableGastos" cols="6"><b-form-input type="number" size="sm" v-model="subsidio.gastos"></b-form-input></b-col>
                        </b-row>
                    </b-col>
                    <b-col v-if="subsidio.aplicado">
                        <b-row class="mt-2">
                            <b-col v-if="subsidio.parametrizableImporte" cols="6"><b class="text-second">% Importe</b></b-col>
                            <b-col v-if="subsidio.parametrizableImporte" cols="6">{{subsidio.importe}}</b-col>
                            <b-col v-if="subsidio.parametrizableActualizacion" cols="6"><b class="text-second">% Actualización</b></b-col>
                            <b-col v-if="subsidio.parametrizableActualizacion" cols="6">{{subsidio.actualizacion}}</b-col>
                            <b-col v-if="subsidio.parametrizableRecargo" cols="6"><b class="text-second">% Recargo</b></b-col>
                            <b-col v-if="subsidio.parametrizableRecargo" cols="6">{{subsidio.recargo}}</b-col>
                            <b-col v-if="subsidio.parametrizableMulta" cols="6"><b> class="text-second"% Multa</b></b-col>
                            <b-col v-if="subsidio.parametrizableMulta" cols="6">{{subsidio.multa}}</b-col>
                            <b-col v-if="subsidio.parametrizableGastos" cols="6"><b class="text-second">% Gastos</b></b-col>
                            <b-col v-if="subsidio.parametrizableGastos" cols="6">{{subsidio.gastos}}</b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>            
        </b-row>
    </b-modal>

    

    <b-modal hide-footer title="¿Desea pagar con puntos BBVA?" v-model="showConfirmaPuntosBBVA" header-bg-variant="dark" header-text-variant="light">
        <b-row align-h="center" align="center">
            <b-col>
                <b-button variant="primary" @click="cobrar('USAR_PUNTOS')" >
                    SI
                </b-button>
                
            </b-col>    
            <b-col>
            
                <b-button variant="secondary" @click="cobrar('NO_USAR_PUNTOS')">
                    No
                </b-button>
            </b-col>           
        </b-row>
    </b-modal>

    <b-modal hide-footer title="Generar convenio" v-model="isShowConvenio"  header-bg-variant="dark" header-text-variant="light">
        <b-row align-h="center" align="center">
            
            <b-col cols="12">
                <b-row align="center" align-h="center">
                    <b-col class="mt-3" cols="12"><h5><b>% Pago Inicial: </b></h5> </b-col>
                    <b-col cols="12" md="10" lg="6"><b-form-input style="text-align: center;" type="number" v-model="pjePagoIConvenio"></b-form-input> </b-col>       
                </b-row>
                <b-row align="center" align-h="center">
                    <b-col class="mt-3" cols="12"><h5><b>No. Parcialidades: </b></h5> </b-col>
                    <b-col cols="12" md="10" lg="6"><b-form-input style="text-align: center;" type="number" v-model="nPagosConvenio"></b-form-input> </b-col>       
                </b-row>
                <b-row align="center" align-h="center">
                    <b-col class="mt-3" cols="12"><h5><b>No. Convenio: </b></h5> </b-col>
                    <b-col cols="12" md="10" lg="6"><b-form-input style="text-align: center;" type="string" v-model="nombreConvenio"></b-form-input> </b-col>       
                </b-row>
                <b-row align="center" align-h="center">
                    <b-col cols="12" md="10" lg="7" class="mt-2">
                        <b-form-checkbox v-model="generarOrdenesConvenio" >Generar formatos de pago</b-form-checkbox>
                    </b-col>
                </b-row>
            </b-col>
            

            <b-col class="mt-3">
                <b-button variant="secondary" @click="isShowConvenio=false">Cancelar <b-icon icon="x-circle-fill"/></b-button>
            </b-col> 
            <b-col class="mt-3">
                <b-button variant="success" @click="generarConvenio">Generar  <b-icon icon="arrow-right-circle-fill"/></b-button>
            </b-col>
            
        </b-row>
        
    </b-modal>

  </b-container>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.4.1/html2canvas.min.js"></script>
<script>
  import Vue from 'vue';
  import axios from 'axios'
  import { mapState} from 'vuex'
  import VueBarcode from 'vue-barcode';
  import VueHtmlToPaper from 'vue-html-to-paper';
  Vue.use(VueHtmlToPaper);
  import { server, checkAuth, getPostConfig, getPostConfigTimeOut, handledError } from '@/axios-tools'
  import { genPdfOrden, genPdfLinea } from '@/vue-tools'

  export default {
    data() {
      return {
        codeClient:this.$route.params.municipio,
        pdfGenerated: null, //Almacena el url con blob del pdf para mostrar en el iframe  
        docJsPDFGenerated : null, //Almacena el ultimo doc generado con jsPDF
        isShowModalOrdenPago: false,
        contenidoOrdenPago: [],
        isShowModalLineaCaptura:false,
        isShowConfirmacionCobro:false,
        isShowConfirmacionOrden:false,
        showConfirmaPuntosBBVA:false,
        windowWidth: window.innerWidth,
        isShowAplicarDescuento : false,
        dineroRecibido:"",
        cambioDinero:"",
        formasPago:[
            "Efectivo",
            "Débito",
            "Transferencia",
			"Cheque",
			"Crédito",
            "Por definir",
        ],
        formaPago:"Efectivo",

        opcionesDefaultOrden : false,
        observacionOrden : '',
        fechaVenceOrden:null,

        activarPinpad:false,
        bancoEmisor:'',
        bancoReceptor:'',
        numTarjeta:'',
        noAutorizacion:'',
        mostrarOpcionPinpad:false,
        desHabilitarDatosBanco:false,

        mesesPinpad:'',

        tipoVencimiento:'a',

        //convenios
        pjePagoIConvenio:20,
        nPagosConvenio:1,
        nombreConvenio:"",
        generarOrdenesConvenio:false,
        isShowConvenio:false
      }
    },
    props:['getLiquidacion'],
    components: {
        'barcode': VueBarcode
    },
    mounted: function(){
      window.onresize = () => {
          this.windowWidth = window.innerWidth
      }
    },
    computed:{
    ...mapState({
        parcialidades: state => state.cobro.parcialidades,
        totalLiquidacion: state => state.cobro.totalLiquidacion,
        token: state => state.login.token,
        formModel : state => state.cobro.formModel,
        liqForms: state => state.cobro.formsModels,
        msgErrorOrdenPago: state => state.cobro.msgErrorOrdenPago,
        isGenerando: state => state.cobro.isGenerando,
        isCalculando: state => state.cobro.isCalculando,
        isCobrando: state => state.cobro.isCobrando,
        datosPago: state => state.cobro.datosPago,
        subsidiosAplicados: state => state.cobro.subsidiosAplicados,
        totalLiquidacion: state => state.cobro.totalLiquidacion,
        catalogCobro: state => state.cobro.catalogCobro
        }),
        anomalia: function(){
            
            for(const idx in this.parcialidades){
                if(this.parcialidades[idx].detalles!=null  && this.parcialidades[idx].pagar){
                    for(const idxD in this.parcialidades[idx].detalles){
                        if(this.parcialidades[idx].detalles[idxD].includes('Anomalía:')){
                            return this.parcialidades[idx].detalles[idxD];
                        }
                    }
                }
            }
            return '';
        },
        timeOutMonitor: {
                get(){return this.$store.state.cobro.timeOutMonitor},
                set(v){this.$store.commit("updateTimeOutMonitor", v);}
            }
    },
    methods: {

        cobrar(modoPuntosBBVA){
            this.isShowConfirmacionCobro=false;
            this.showConfirmaPuntosBBVA = false;
            if(!this.isCalculando && !this.isGenerando && checkAuth(this.$router, this.$store)){
                this.$store.commit("updateIsCobrando", true);
                if(this.activarPinpad){
                    const montoCobro = this.totalLiquidacion.replace(',','');
                    axios(
                        getPostConfig(server.gent3pinpad, this.liqForms, this.token, {monto:montoCobro})
                    ).then(resT3 => {
                        const formPP = {
                            "adq" : resT3.data.config.adq,
                            "action": "COMPRA",
                            "monto" : montoCobro,
                            "concecutivo" : resT3.data.idT3D,
                            "referencia" : resT3.data.referencia,
                            "sucursal" : resT3.data.config.sucursal,
                            "entidad" : resT3.data.config.entidad,
                            "correoComercio" : resT3.data.config.correoComercio,
                            "concepto" : resT3.data.config.concepto,
                            "meses" : this.mesesPinpad,
                            "puntos" : typeof modoPuntosBBVA == "string" ? modoPuntosBBVA :""
                        }
                        const config = getPostConfigTimeOut(server.cobroPinpad, formPP, null , null, this.timeOutMonitor);
                        config.headers = { 
                            'Content-Type': 'application/json'
                        };
                        axios(
                            config
                        ).then(resPinpadObject => {

                            let esObjeto = typeof resPinpadObject.data == 'object';
                            let resPinpad = esObjeto ? JSON.stringify(resPinpadObject.data) : resPinpadObject.data;

                            if(resPinpad.toUpperCase().includes('APROBADA')){
                                if(esObjeto){
                                    alert(resPinpadObject.data.status);
                                }

                                for(var i=0; i<this.liqForms.length; i++){
                                    this.liqForms[i].resPinpadDes = resPinpad;
                                    this.liqForms[i].idT3DPinpad=resT3.data.idT3D;
                                    if(resPinpad.toUpperCase().includes('DEBIT')){
                                        this.formaPago='Débito';
                                    }else if(resPinpad.toUpperCase().includes('CREDIT')){
                                        this.formaPago='Crédito';
                                    }else{
                                        this.formaPago='Débito';
                                    }
                                }
                                this.cobrarOk();
                            }else if(resPinpad.toUpperCase().includes('BBVA_PUNTOS')){
                                this.$store.commit("updateIsCobrando", false);
                                this.showConfirmaPuntosBBVA = true;
                            }else{
                                this.$store.commit("updateIsCobrando", false);
                                let msje = esObjeto? resPinpadObject.data.status : resPinpad;
                                alert(msje);
                                
                            }
                        }).catch(err => {
                            this.$store.commit("updateIsCobrando", false);
                            handledError(err, server.cobro, this.$router, this.$store);
                        })
                    }).catch(err => {
                        this.$store.commit("updateIsCobrando", false);
                        handledError(err, server.cobro, this.$router, this.$store);
                    })
                }else{
                    this.cobrarOk();
                }
            }
        },
        cobrarOk(){
            for(var i=0; i<this.liqForms.length; i++){
                this.liqForms[i].isConFacturaGral = this.formModel.isConFacturaGral;
                this.liqForms[i].formaPagoDesc = this.formaPago;
                this.liqForms[i].formaPagoDesc = this.formaPago;
            }
            axios(
                getPostConfig(server.cobro, this.liqForms, this.token)
            ).then(res => {
                this.$store.commit("clearResultsCobro");
                this.$store.commit("updatePdfsGenerated", res.data);
                this.$store.commit("updateIsShowModalCobro", true);
                this.$store.commit("updateIsCobrando", false);
            }).catch(err => {
                this.$store.commit("updateIsCobrando", false);
                handledError(err, server.cobro, this.$router, this.$store);
            })
                            
        },
        generarOrdenPago(isSoloImprimir){
            this.isShowConfirmacionOrden=false;
            if(!this.isCalculando && !this.isGenerando){
                this.$store.commit("updateIsGenerando", true);
                this.cleanResultsOrdenPago();
                for(var i=0; i<this.liqForms.length; i++){
                    this.liqForms[i].isLineaCaptura = this.formModel.isLineaCaptura;
                    
                    if(!this.opcionesDefaultOrden && this.fechaVenceOrden!=null){
                        this.liqForms[i].fechaVencimiento.model = this.fechaVenceOrden;
                        if(this.observacionOrden!=null && this.observacionOrden!=''){
                            this.liqForms[i].inTxtObs.model = this.liqForms[i].inTxtObs.model+ ' '+this.observacionOrden;
                        }
                    }else{
                        this.liqForms[i].fechaVencimiento.model = null;
                    }
                    
                }

               
                if(checkAuth(this.$router, this.$store)){
                    axios(
                        getPostConfig(server.ordenpago, this.liqForms, this.token, {soloLiquidacion:isSoloImprimir})
                    ).then(res => {
                        this.$store.commit("updatePdfsGenerated", res.data);
                        this.$store.commit("updateIsShowModalCobro", true);
                        this.$store.commit("updateIsGenerando", false);
                    }).catch(err => {
                        this.$store.commit("updateIsGenerando", false);
                        handledError(err, server.ordenpago, this.$router, this.$store);
                    })
                }
            
            }
        },
        generarConvenio(){
            
            if(!this.isCalculando && !this.isGenerando){
                this.$store.commit("updateIsGenerando", true);
                this.cleanResultsOrdenPago();
                for(var i=0; i<this.liqForms.length; i++){
                    this.liqForms[i].isLineaCaptura = this.formModel.isLineaCaptura;
                    
                    if(!this.opcionesDefaultOrden && this.fechaVenceOrden!=null){
                        this.liqForms[i].fechaVencimiento.model = this.fechaVenceOrden;
                        if(this.observacionOrden!=null && this.observacionOrden!=''){
                            this.liqForms[i].inTxtObs.model = this.liqForms[i].inTxtObs.model+ ' '+this.observacionOrden;
                        }
                    }else{
                        this.liqForms[i].fechaVencimiento.model = null;
                    }
                    this.liqForms[i].porcentajePagoInicialConvenio=this.pjePagoIConvenio;
                    this.liqForms[i].numPagosConvenio=this.nPagosConvenio;
                    this.liqForms[i].nombreConvenio=this.nombreConvenio==null || this.nombreConvenio=='' ? 'SN':this.nombreConvenio;
                    this.liqForms[i].generarFormatosConvenio=this.generarOrdenesConvenio;
                    
                }

                this.isShowConvenio = false;
                if(checkAuth(this.$router, this.$store)){
                    axios(
                        getPostConfig(server.generarconvenio, this.liqForms, this.token, {})
                    ).then(res => {
                        
                        this.$store.commit("updatePdfsGenerated", res.data);
                        this.$store.commit("updateIsShowModalCobro", true);
                        
                        this.$store.commit("updateIsGenerando", false);
                    }).catch(err => {
                        this.$store.commit("updateIsGenerando", false);
                        handledError(err, server.generarconvenio, this.$router, this.$store);
                    })
                }
            
            }
        },
        // generarOrdenPago(isSoloImprimir){
        //     if(!this.isCalculando && !this.isGenerando){
        //         this.$store.commit("updateIsGenerando", true);
        //         this.cleanResultsOrdenPago();
        //         if(isSoloImprimir){
        //             this.$store.commit("updateIsGenerando", false);
        //             this.generarPdf(isSoloImprimir);
        //         }else{
        //             if(checkAuth(this.$router, this.$store)){
        //                 axios(
        //                     getPostConfig(server.ordenpago, this.liqForms, this.token)
        //                 ).then(res => {
        //                     this.contenidoOrdenPago = res.data;
        //                     this.generarPdf(isSoloImprimir);
        //                     this.$store.commit("updateIsGenerando", false);
        //                 }).catch(err => {
        //                     this.$store.commit("updateIsGenerando", false);
        //                     handledError(err, server.ordenpago, this.$router, this.$store);
        //                 })
        //             }
        //         }   
        //     }
        // },
        generarPdf(isSoloImprimir){
            if(isSoloImprimir){
                var parcialidadesCobrables = [this.formModel.idxUltParcialidad+1];
                for (var index in this.parcialidades){
                    if(index <= this.formModel.idxUltParcialidad){
                        parcialidadesCobrables[index] = [ 
                            this.parcialidades[index].periodo, 
                            this.parcialidades[index].importe, 
                            this.parcialidades[index].recargo, 
                            this.parcialidades[index].multa, 
                            this.parcialidades[index].pae, 
                            this.parcialidades[index].subsidios, 
                            this.parcialidades[index].total ]
                    }
                }
                this.pdfGenerated = genPdfLinea(this.datosPago[0].detalle, parcialidadesCobrables, this.totalLiquidacion, null, false, null, null, null, this.catalogCobro.logoMpio2, null, this.$route.params.municipio);
                this.isShowModalLineaCaptura = true;
            }else{
                var detalle = this.contenidoOrdenPago.detalle;
                var municipio = this.contenidoOrdenPago.municipio;
                var totalLiquidacion = this.contenidoOrdenPago.total;
                var fecha = this.contenidoOrdenPago.fecha;
                var fechav = this.contenidoOrdenPago.fechav;
                var total = this.contenidoOrdenPago.total;
                var folio = this.contenidoOrdenPago.folio;
                var qrCodi = this.contenidoOrdenPago.qrCodi;
                if(this.formModel.isLineaCaptura == 'true'){ //se compara especificamente con 'true' 
                    //var formasPago = this.contenidoOrdenPago.formasPago;
                    var formasPago = [this.contenidoOrdenPago.formasPago.length];
                    for (var idxFormasPago in this.contenidoOrdenPago.formasPago){
                        formasPago[idxFormasPago] = [this.contenidoOrdenPago.formasPago[idxFormasPago].nombre  + " - " + this.contenidoOrdenPago.formasPago[idxFormasPago].ref];
                    }
                    var parcialidades = [this.contenidoOrdenPago.parcialidades.length];
                    for (var index in this.contenidoOrdenPago.parcialidades){
                        parcialidades[index] = [ 
                            this.contenidoOrdenPago.parcialidades[index].periodo, 
                            this.contenidoOrdenPago.parcialidades[index].importe, 
                            this.contenidoOrdenPago.parcialidades[index].recargo, 
                            this.contenidoOrdenPago.parcialidades[index].multa, 
                            this.contenidoOrdenPago.parcialidades[index].pae, 
                            this.contenidoOrdenPago.parcialidades[index].subsidios, 
                            this.contenidoOrdenPago.parcialidades[index].total ];
                    }
                    this.pdfGenerated = genPdfLinea(detalle, parcialidades, total, formasPago, true, fecha, fechav, folio, this.catalogCobro.logoMpio2, qrCodi, this.$route.params.municipio);
                    this.isShowModalLineaCaptura = true;
                }else{
                    var usuario = this.contenidoOrdenPago.usuario;
                    JsBarcode("#barcode", this.contenidoOrdenPago.folio, {format: "CODE128", width: 5, height: 150, displayValue : false});
                    this.pdfGenerated = genPdfOrden(municipio, fecha, usuario, detalle, total, 'barcode', this.contenidoOrdenPago.folio, this.catalogCobro.logoMpio2);
                    this.isShowModalOrdenPago = true;
                }
            }
        },
        downloadLinea(){
            var downloadPdf = document.createElement('a');
            downloadPdf.setAttribute('href', this.pdfGenerated);
            downloadPdf.setAttribute('download', "formatoPago.pdf");
            downloadPdf.click();
        },
        downloadOrdenPago(){
            var downloadPdf = document.createElement('a');
            downloadPdf.setAttribute('href', this.pdfGenerated);
            downloadPdf.setAttribute('download', "ordenPago.pdf");
            downloadPdf.click();
        },
        printOrdenPago(){
            document.getElementById('embed1').contentWindow.print();
        },
        cleanResultsCobro(){
                if(!this.isCalculando & !this.isGenerando ){
                    this.$store.commit("clearResultsCobro");
                }
            },
        cleanResultsOrdenPago(){
             if(!this.isCalculando & !this.isGenerando ){
                this.$store.commit("updateMsgErrorOrdenPago", null);
                this.contenidoOrdenPago = [];
             }
        },
        agregarClave(clave, nombreGrupo, importe, actualizacion, recargo, multa, gastos){
            if(  !this.isCalculando ){
                this.$store.commit("updateMsgErrorLiquidacion", null);        
                this.$store.commit("updateIsCalculando", true);
                this.isShowAplicarDescuento=false;
                //alert(importe+' '+ actualizacion+' '+ recargo+' '+ multa+' '+ gastos);
                axios(
                    getPostConfig(server.agregasubsidio, null, this.token, 
                    {
                        clave: clave, 
                        grupo:nombreGrupo,
                        importe: importe,
                        actualizacion : actualizacion,
                        recargo : recargo,
                        multa : multa,
                        gastos : gastos
                    
                    })
                )
                .then(() => {
                    this.$store.commit("updateIsCalculando", false);
                    alert("El subsidio fue aplicado.");
                    this.getLiquidacion(false, true);
                }).catch(err => {
                    handledError(err, server.agregasubsidio, this.$router, this.$store);
                    this.$store.commit("updateIsCalculando", false);
                });
            }
        },
        eliminarClave(clave, idGrupo){
            if(  !this.isCalculando){
                this.$store.commit("updateMsgErrorLiquidacion", null);        
                this.$store.commit("updateIsCalculando", true);
                this.isShowAplicarDescuento=false;
                axios(
                    getPostConfig(server.quitasubsidio, null, this.token, {clave: clave, idGrupo:idGrupo})
                )
                .then(() => {
                    this.$store.commit("updateIsCalculando", false);
                    alert("El subsidio se eliminó.");
                    this.getLiquidacion(false, true);
                }).catch(err => {
                    handledError(err, server.quitasubsidio, this.$router, this.$store);
                    this.$store.commit("updateIsCalculando", false);
                });
            }
        },
        calculaCambio(){
            var totalCobro = this.totalLiquidacion.replace(',','');
            this.cambioDinero = this.dineroRecibido.replace(',','') - totalCobro;
        },
        showConfirmacionCobro(){
            this.formaPago ='Efectivo';
            this.dineroRecibido = '';
            this.isShowConfirmacionCobro=true;
            this.configFormaPago();
        },
        showConfirmaOrden(){
            this.isShowConfirmacionOrden=true;
            this.opcionesDefaultOrden=true;
            this.fechaVenceOrden=null;
            this.observacionOrden='';
            this.tipoVencimiento ='a'
        },
        configFormaPago(){
            this.bancoEmisor='';
            this.bancoReceptor='';
            this.numTarjeta='';
            this.noAutorizacion='';

            this.mostrarOpcionPinpad=this.catalogCobro.pinpadContrato && (this.formaPago.includes('ito'));

            this.activarPinpad = this.mostrarOpcionPinpad ;

            this.mesesPinpad = '';
        },
        asignaFechaVencimientoPorDias(dias) {
            if(dias == null){
                this.fechaVenceOrden =  '';
            }else{
                // Obtener fecha actual
                let fecha = new Date();

                // Sumar los días
                fecha.setDate(fecha.getDate() + dias);

                // Formatear a AAAA-MM-DD
                let year = fecha.getFullYear();
                let month = String(fecha.getMonth() + 1).padStart(2, '0'); // Mes empieza en 0
                let day = String(fecha.getDate()).padStart(2, '0');

                let fechaFormateada = `${year}-${month}-${day}`;

                // Mostrar en alert
                //alert(fechaFormateada);
                this.fechaVenceOrden =  fechaFormateada;
            }
        }
    }
  }
</script>
<style>
.row-button-download{
    margin-top:5px;
}
.text-second{
    color: #888888;
}
</style>